import { TMessage, TMessageParam } from "@/i18n/tt";
import { useTranslation } from "@/stores/RootStoreContext";
import { HoverTooltip } from "./Tooltip";

export type TextWithTooltipUnderline = "dotted" | "solid" | "none";

export type TextWithTooltipProps = {
  text: TMessage;
  tooltip?: TMessage | TMessageParam;
  underline?: TextWithTooltipUnderline;
};

const underlineClassNames: Record<TextWithTooltipUnderline, string | undefined> = {
  dotted: "underline decoration-dotted",
  solid: "underline",
  none: undefined,
};

export function TextWithTooltip({ text, tooltip, underline = "dotted" }: TextWithTooltipProps) {
  const { t } = useTranslation();
  if (!tooltip) {
    return <div>{t(text)}</div>;
  }
  return (
    <HoverTooltip content={t(tooltip)}>
      {({ targetRef }) => (
        <span ref={targetRef} className={underlineClassNames[underline]}>
          {t(text)}
        </span>
      )}
    </HoverTooltip>
  );
}
